import { CreateTemplateCategoryV2, CreateTemplateCategoryV2Variables } from './__generated__/CreateTemplateCategoryV2'
import { CreateTemplateMessageV2, CreateTemplateMessageV2Variables } from './__generated__/CreateTemplateMessageV2'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const CATEGORY_MUTATION = gql`
  mutation CreateTemplateCategoryV2($input: CreateTemplateCategoryInputV2!) {
    createColorTemplate: createTemplateCategoryV2(input: $input) {
      __typename
      ... on TemplateCategoryV2 {
        id
        title
      }
      ... on TemplateCategoryErrorV2 {
        type
        error
      }
    }
  }
`

const MESSAGE_MUTATION = gql`
  mutation CreateTemplateMessageV2($input: CreateTemplateMessageInputV2!) {
    createTemplateMessageV2(input: $input) {
      __typename
      ... on TemplateMessageV2 {
        id
      }
      ... on TemplateMessageErrorV2 {
        type
        error
      }
    }
  }
`

export const useCreateColorTemplate = () => {
  return useMutation<CreateTemplateCategoryV2, CreateTemplateCategoryV2Variables>(CATEGORY_MUTATION)
}

export const useCreateTemplateMessage = () => {
  return useMutation<CreateTemplateMessageV2, CreateTemplateMessageV2Variables>(MESSAGE_MUTATION)
}
